// HR-PERSONA-001 — hr_specialist (alias 'hr') is read-only across HR/Recruitment UIs.
export const isHrReadOnly = () => {
  try {
    const role = JSON.parse(localStorage.getItem('user') || '{}').role;
    return role === 'hr_specialist' || role === 'hr';
  } catch {
    return false;
  }
};
